"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var GenericInput_1 = require("../genericInput/GenericInput");
var DatePickerInput = function (_a) {
    var props = _a.props, formData = _a.formData, toggleDatePicker = _a.toggleDatePicker, errorMessage = _a.errorMessage;
    var label = formData.label, required = formData.required, id = formData.id, onChange = formData.onChange, value = formData.value, inputLabel = formData.options.inputLabel;
    react_1.useEffect(function () {
        onChange(formattedDate(props.value));
    }, [props.value]);
    var handleChange = react_1.useCallback(function (e) {
        onChange(formattedDate(e.target.value));
    }, [value]);
    var formattedDate = function (value) {
        return value.replace(/\//g, '-');
    };
    return (<GenericInput_1.default label={label} required={required} id={id} value={props.value} currentError={errorMessage} onChange={handleChange} inputLabel={inputLabel} datePicker={true} toggleDatePicker={toggleDatePicker}/>);
};
exports.default = DatePickerInput;
